import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import { VTCHome } from "./components/VTCHome";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const TestConnection = () => {
  const helloWorldApi = async () => {
    try {
      const response = await axios.get(`${API}/`);
      console.log(response.data.message);
    } catch (e) {
      console.error(e, `errored out requesting / api`);
    }
  };

  useEffect(() => {
    helloWorldApi();
  }, []);

  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <TestConnection />
        <Routes>
          <Route path="/" element={<VTCHome />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;